import * as React from 'react';
// @ts-ignore
import style from './InfoButton.module.scss?module';
import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import { useAtom } from 'jotai';
import { sellSheetOpenAtom } from '../../../../Atoms/SellSheetOpen';

export default function InfoButton({
  product_size,
}: {
  product_size: ProductSizeInterface;
}) {
  const [open, setOpen] = useAtom(sellSheetOpenAtom(product_size.id));
  return (
    <div
      role="button"
      className={[
        'text-white text-decoration-none d-flex align-items-center justify-content-center',
        open ? 'bg-primary' : 'bg-light-gray',
        style.productInfoButton,
      ].join(' ')}
      onClick={() => setOpen(!open)}
    >
      <FontAwesomeIcon size="xl" icon={faInfo} />
    </div>
  );
}
